import { getDataFromPocket } from '../../utils/pocket';
import type { DLParams, JobParams, RCParams } from './utils-pocket-models';

export function sendBogoEvent() {
    const vueState = JSON.parse(document.getElementById('app-state')?.textContent ?? '{}');
    const finalLocale = vueState.geolocation?.finalLocale;

    const dlParams = getDataFromPocket<DLParams>('ga_dl_params', false) || {};
    const rcParams = getDataFromPocket<RCParams>('ga_rc_params', false) || {};
    const jobParams = getDataFromPocket<JobParams>('ga_job_params', false) || {};

    const splitsDimensionsPairs = (window.splitsCurrentActiveSet || [])
        .filter((x) => Boolean(x.dimension))
        .map((x) => [x.dimension, `${x.id}.${x.variant}`]);

    const dimensions = { ...Object.fromEntries(splitsDimensionsPairs) };

    const sixSenseRedirectType = sessionStorage?.getItem('6senseRedirect');
    const sixSenseRedirectParams = sixSenseRedirectType
        ? { Test_Cell_121: `WEB_45334.${sixSenseRedirectType}` }
        : {};

    const event = {
        event: 'BOGO',
        touchpoint: 'website',
        siteLocale: finalLocale || '(not set)',
        DL_PageType: dlParams.DL_PageType || '(not set)',
        DL_Audience: dlParams.DL_Audience || '(not set)',
        DL_Product: dlParams.DL_Product || '(not set)',
        rcProduct: rcParams.rcProduct || '(not set)',
        rcFeatured: rcParams.rcFeatured || '(not set)',
        rcCategory: rcParams.rcCategory || '(not set)',
        rcType: rcParams.rcType || '(not set)',
        ...jobParams,
        ...dimensions,
        ...sixSenseRedirectParams,
    };

    window.dataLayer.push(event);
}
